module.exports = __webpack_public_path__ + "img/logo-valcar.bd948f81.svg";